export default __webpack_public_path__ + "static/media/wavedown.9f3fee23.svg";